// Entscheidungen der Wischgeste — reine Rechnerei, kein DOM.
//
// Der Aufrufer sammelt die Messwerte und fragt hier nach. Dadurch lässt sich
// genau das prüfen, was sonst nur von Hand am Telefon prüfbar wäre: ab wann
// die Geste auslöst und wann sie sich zurückhalten muss.

/** Wie breit der Streifen am Rand ist, in dem die Geste beginnen darf. */
export const RANDBREITE = 24;

/** Ab diesem Anteil der Bildschirmbreite gilt der Wisch als gewollt. */
export const SCHWELLE_ANTEIL = 0.34;

/** px je Millisekunde. Darüber reicht auch ein kurzer Weg. */
export const SCHWELLE_TEMPO = 0.45;

export type Richtung = 'ltr' | 'rtl';

/** Eine Zeile der Elternkette über dem angetippten Element. */
export type Bahnglied = {
  scrollWidth: number;
  clientWidth: number;
  scrollLeft: number;
  /** `overflow-x` aus den berechneten Stilen. */
  ueberlaufX: string;
};

/**
 * Liegt der Startpunkt im Randstreifen?
 *
 * Auf Arabisch läuft die Oberfläche von rechts nach links; „zurück" ist dort
 * ein Wisch nach links, der am rechten Rand beginnt. Die Richtung kommt aus
 * `document.dir` und steht nicht fest im Code.
 */
export function imStartbereich(x: number, breite: number, richtung: Richtung): boolean {
  return richtung === 'rtl' ? x >= breite - RANDBREITE : x <= RANDBREITE;
}

/** Zurückgelegter Weg in Leserichtung. Ein Zug in die Gegenrichtung zählt nicht. */
export function wegAus(x: number, start: number, richtung: Richtung): number {
  const d = richtung === 'rtl' ? start - x : x - start;
  return d > 0 ? d : 0;
}

/**
 * Soll der Wisch die Seite verlassen?
 *
 * Zwei Wege führen dahin: weit genug gezogen, oder schnell genug losgelassen.
 * Ohne den zweiten fühlt sich die Geste zäh an — ein kurzer schneller Wisch
 * ist die übliche Art, zurückzugehen. Bei null Weg zählt kein Tempo: das wäre
 * ein Tippen, kein Wisch.
 */
export function loestAus(weg: number, breite: number, tempo: number): boolean {
  if (weg <= 0) return false;
  return weg > breite * SCHWELLE_ANTEIL || tempo > SCHWELLE_TEMPO;
}

/**
 * Liegt unter dem Finger etwas, das selbst seitwärts gescrollt ist?
 *
 * Dann gehört die Bewegung diesem Bereich und nicht der Navigation. Steht er
 * noch ganz am Anfang, will der Benutzer sehr wahrscheinlich zurück — also
 * blockt nur ein bereits verschobener Scroller.
 */
export function scrollerDavor(bahn: Bahnglied[]): boolean {
  return bahn.some(g =>
    g.scrollWidth > g.clientWidth
    && (g.ueberlaufX === 'auto' || g.ueberlaufX === 'scroll')
    && g.scrollLeft > 0);
}
